import { render, staticRenderFns } from "./allocationStorehouseManageList.vue?vue&type=template&id=2d8d3398&scoped=true"
import script from "./allocationStorehouseManageList.vue?vue&type=script&lang=js"
export * from "./allocationStorehouseManageList.vue?vue&type=script&lang=js"
import style0 from "./allocationStorehouseManageList.vue?vue&type=style&index=0&id=2d8d3398&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8d3398",
  null
  
)

export default component.exports